export const newsletterFormData = {
    message: 'Dostosuj kategorie',
    text: 'Jakie kategorie interesują Cię najbardziej?',
    errors: {
        requiredMessage: 'Adres e-mail jest wymagany',
        patternMessage: 'Adres e-mail jest niepoprawny',
        errorMessage: 'Wystąpił problem spróbuj ponownie',
        emailMessage: 'Podany adres e-mail jest już w naszej bazie. Prosimy spróbować z innym adresem e-mail'
    },
    list: [
        { label: 'AGD', name: 'agd' },
        { label: 'RTV', name: 'rtv' },
        { label: 'Gry wideo', name: 'games' },
        { label: 'Laptopy i komputery', name: 'computers' },
        { label: 'Smartfony', name: 'smartphones' },
        { label: 'Foto/wideo', name: 'photo' }
    ]
};
